import type { AxiosError } from '@ori/axios';
import { action, runInAction } from 'mobx';

import { BaseStore } from './BaseStore';
import type { Subcategory } from '~/models/supportCenter';

export class MostCommonQuestionsStore extends BaseStore {
  mostCommonQuestions: Subcategory = { Questions: [], Title: '' };

  @action
  loadMostCommonQuestions = async () => {
    const url = '/applications/supportCenter/featuredFaqs';
    const response = await this.getUrl<Subcategory>(url);

    if (response.data) {
      runInAction(() => {
        this.mostCommonQuestions = response.data;
      });
    }

    if (response.error !== undefined) {
      runInAction(() => {
        this.networkError = response.error as AxiosError;
      });
    }

    return response;
  };
}
